import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C10.2051 2.75 8.75 4.20507 8.75 6C8.75 7.79493 10.2051 9.25 12 9.25C13.7949 9.25 15.25 7.79493 15.25 6C15.25 4.20507 13.7949 2.75 12 2.75ZM7.25 6C7.25 3.37665 9.37665 1.25 12 1.25C14.6234 1.25 16.75 3.37665 16.75 6C16.75 8.62335 14.6234 10.75 12 10.75C9.37665 10.75 7.25 8.62335 7.25 6Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 14.75C15.2051 14.75 13.75 16.2051 13.75 18C13.75 19.7949 15.2051 21.25 17 21.25C18.7949 21.25 20.25 19.7949 20.25 18C20.25 16.2051 18.7949 14.75 17 14.75ZM12.25 18C12.25 15.3766 14.3766 13.25 17 13.25C19.6234 13.25 21.75 15.3766 21.75 18C21.75 20.6234 19.6234 22.75 17 22.75C14.3766 22.75 12.25 20.6234 12.25 18Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4697 20.4697L19.4697 14.4697L20.5303 15.5304L14.5303 21.5304L13.4697 20.4697Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.42236 14.8228C6.26701 15.483 5.75 16.2807 5.75 17C5.75 17.7193 6.26701 18.517 7.42236 19.1772C8.55649 19.8253 10.1733 20.25 12 20.25C12.6536 20.25 13.2828 20.1956 13.8743 20.095L14.1257 21.5737C13.4498 21.6887 12.7364 21.75 12 21.75C9.96067 21.75 8.07752 21.2792 6.67815 20.4796C5.3 19.6921 4.25 18.4899 4.25 17C4.25 15.5101 5.3 14.3079 6.67815 13.5204C8.07752 12.7208 9.96067 12.25 12 12.25C13.8103 12.25 15.4933 12.6207 16.8246 13.2598L16.1754 14.6121C15.0731 14.0829 13.6167 13.75 12 13.75C10.1733 13.75 8.55649 14.1747 7.42236 14.8228Z"
        fill={colorValue}
      />
    </svg>
  );
};
